// extracted by mini-css-extract-plugin
module.exports = {"next":"_ae96a69","numericPin":"_13086c7"};